import html from "./MyDataHelps.html"
import { getUrlEncodedViewForTab } from "../../helpers/MyDataHelps/getRootViewForTab";
import { decodeUrlBase64, encodeUrlBase64 } from "../../helpers/MyDataHelps/base64UrlEncode";
import "./../../components/MyDataHelps/colors.css"
import "./../../components/MyDataHelps/global.css"
import "./MyDataHelps.css"
import "./Views/ConfirmPatientMatch"
import "./Views/Dashboard.js"
import "./Views/Share.js"
import "./Views/PatientEventsViewer.js"
import "./Views/ExternalApplication.js"
import "./Views/ExternalApplicationModal.js"
import "./Views/Dashboard.js"
import "./Views/MyProviderAccounts.js"
import "./Views/ProviderSearch.js"
import "./Views/SurveyList.js"
import "./Views/ProjectDetail.js"
import "./Views/NewsFeed.js"
import "./CancelAccount.js"
import "../Shared/UrlWhitelistValidator.js"
import "../Survey/SurveyStep.js"
import "../Survey/SurveyCompletion/SurveyContainer.js"
import { captureDeviceInfo } from "../../helpers/MyDataHelps/participantDeviceInfo"
import { connectExternalAccount, linkAccount } from "../../helpers/providerAccounts";
import "../Survey/SurveyCompletion/UpdateEmailSurveyContainer.js"
import "../Survey/SurveyCompletion/UpdateMobileNumberSurveyContainer.js"
import "./MyDataHelpsReactComponent.jsx"
import "../Shared/Translate.js"

var module = angular.module("ResearchKitApplicationModule");

$(document).ready(function () {
    if (!$(".mydatahelps-app").length) { return; }

    var configuration = JSON.parse(document.getElementById('AntiXssModelInit').textContent);
    var brandConfiguration = JSON.parse(document.getElementById('AntiXssBrandInit').textContent);
    var usingInternetExplorer = JSON.parse(document.getElementById('AntiXssInternetExplorerInit').textContent);

    var myDataHelpsModule = angular.module("MyDataHelpsModule", ['CareEvWidgets', 'newsFeedApplication', 'ngSanitize', 'ngRoute', 'ResearchKitApplicationModule', 'ngCookies', 'pascalprecht.translate', 'ngAria']);
    module.constant("WebViewStepFrameUrl", configuration.WebViewStepFrameUrl)
        .constant("delegatedOAuthClient", configuration.DelegatedOAuthClient)
        .constant("availableLocales", configuration.AvailableLocales);

    angular.module('newsFeedApplication')
        .value('language', configuration.NewsFeedLanguage);

    myDataHelpsModule.component('mydatahelps', {
        template: html,
        controller: 'MyDataHelpsController',
        controllerAs: 'vm'
    });

    myDataHelpsModule.controller("MyDataHelpsController", ["$scope", "$http", "$timeout", "$location", "$window", "$translate", "ceUrl",
        function ($scope, $http, $timeout, $location, $window, $translate, ceUrl) {
            if (brandConfiguration.Logo.Path.startsWith("~")) {
                brandConfiguration.Logo.Path = ceUrl.make(brandConfiguration.Logo.Path.substr(1));
            }
            $scope.brandConfiguration = brandConfiguration;
            $scope.usingInternetExplorer = usingInternetExplorer;
            $scope.availableLanguageKeys = $translate.getAvailableLanguageKeys();
            $scope.showLanguageSwitcher = $scope.availableLanguageKeys.length > 1;
            $scope.$root.$on("$translateChangeEnd", function () {
                $scope.currentLanguage = $translate.use();
            });
            $scope.changeLanguage = function (lang) {
                $translate.use(lang).then(function () {
                    $window.location.reload();
                });
            };

            let currentWhitelistedUrls = null;
            $scope.getWhitelistedUrls = function () {
                function buildWhitelist() {
                    if ($scope.selectedProject && $scope.participantInfo) {
                        const selectedProjectExternalAppWhitelistedUrls = $scope.participantInfo.ExternalApplicationWhitelistedUrls.find(function (wu) {
                            return wu.ProjectID === $scope.selectedProject;
                        });
                        return selectedProjectExternalAppWhitelistedUrls ? selectedProjectExternalAppWhitelistedUrls.WhitelistedUrls : [];
                    } else if ($scope.participantInfo) {
                        return ["**"];
                    } else {
                        return [];
                    }
                }

                let newWhitelistedUrls = buildWhitelist();
                if (!angular.equals(currentWhitelistedUrls, newWhitelistedUrls)) {
                    currentWhitelistedUrls = newWhitelistedUrls;
                }
                return currentWhitelistedUrls;
            }

            function generateTabsHash(tabs) {
                var hash = "" + tabs.length + "|";
                _.each(tabs, function (tab) { hash += tab.Type + "^" + tab.Title + "^" + tab.Key + "|"; });
                return hash;
            }

            function getParticipantTabs(participantInfo, selectedProject) {
                if (participantInfo.ProjectTabBars.length) {
                    if (selectedProject) {
                        return _.find(participantInfo.ProjectTabBars, function (project) { return project.ProjectID === selectedProject; }).Tabs;
                    } else {
                        return participantInfo.ProjectTabBars[0].Tabs;
                    }
                }
                return [];
            }

            function showDefaultTab() {
                $http.get(ceUrl.make("api/researchkit/studyparticipant/userpreference/mdh.selectedproject")).then(function (preferenceResponse) {
                    var initialTab = $scope.participantInfo.Tabs[0];
                    var projectID = "-";
                    var lastSelectedProject = preferenceResponse.data;

                    if ($scope.participantInfo.ProjectTabBars.length) {
                        var index = 0;
                        if (lastSelectedProject.projectID) {
                            var foundIndex = $scope.participantInfo.ProjectTabBars.findIndex((projectTabBar) => projectTabBar.ProjectID === lastSelectedProject.projectID);
                            index = foundIndex >= 0 ? foundIndex : index;
                        }
                        projectID = $scope.participantInfo.ProjectTabBars[index].ProjectID;
                        initialTab = $scope.participantInfo.ProjectTabBars[index].Tabs[0];
                    }

                    var initialView = getUrlEncodedViewForTab(initialTab.Type, initialTab.Properties, $scope.participantInfo.SessionID);
                    $location.path("/" + projectID + "/" + initialTab.Key + "/" + initialView);
                    $scope.selectedProject = projectID;
                });
            }

            function loadParticipantInfo(evt, projectToSelect) {
                $scope.loadingParticipantInfo = true;

                $http.get(ceUrl.make("api/researchkit/studyparticipant/status?topNavigationSupported=true&tabsKey=" + configuration.TabsKey + "&platform=web")).then(function (response) {
                    $scope.participantInfo = response.data;

                    var tabToSelect;
                    if ($scope.pendingAction) {
                        projectToSelect = $scope.pendingAction.projectID;
                        tabToSelect = $scope.pendingAction.tabKey;
                    }

                    var participantTabs = getParticipantTabs($scope.participantInfo, projectToSelect || $scope.selectedProject);
                    var tabsHash = generateTabsHash(participantTabs);

                    if (!$location.path() || $location.path() === "/") {
                        showDefaultTab();
                    } else if (projectToSelect && $scope.participantInfo.ProjectTabBars.length) {
                        var initialTab = null;
                        if (tabToSelect) {
                            var project = _.find($scope.participantInfo.ProjectTabBars, function (project) { return project.ProjectID == $scope.pendingAction.projectID; });
                            initialTab = _.find(project.Tabs, function (tab) { return tab.Key === tabToSelect; });
                        }
                        else {
                            initialTab = _.find($scope.participantInfo.ProjectTabBars, function (project) { return project.ProjectID == projectToSelect; }).Tabs[0];
                        }
                        var initialView = getUrlEncodedViewForTab(initialTab.Type, initialTab.Properties, $scope.participantInfo.SessionID);
                        $location.path("/" + projectToSelect + "/" + initialTab.Key + "/" + initialView);
                        $scope.selectedProject = projectToSelect;
                    } else if ($scope.tabsHash && tabsHash !== $scope.tabsHash) {
                        var initialTab = participantTabs[0];
                        var initialView = getUrlEncodedViewForTab(initialTab.Type, initialTab.Properties, $scope.participantInfo.SessionID);
                        $location.path("/" + $scope.selectedProject + "/" + initialTab.Key + "/" + initialView);
                    }
                    $scope.tabsHash = tabsHash;
                }).finally(function () {
                    $scope.loadingParticipantInfo = false;
                });
            }

            $scope.$on("refreshParticipantInfo", loadParticipantInfo);

            $scope.getSelectedTabTitle = function () {
                if (!$scope.participantInfo) { return ''; }
                if ($scope.participantInfo.ProjectTabBars.length) {
                    var selectedTabBar = _.find($scope.participantInfo.ProjectTabBars, function (tabBar) { return tabBar.ProjectID == $scope.selectedProject });
                    var selectedTab = _.find(selectedTabBar.Tabs, function (tab) { return tab.Key == $scope.selectedTab });
                    return selectedTab.Title;
                }
                return '';
            };

            function goToView(view) {
                $location.path("/" + ($scope.selectedProject || "-") + "/" + $scope.selectedTab + "/" + encodeUrlBase64(view, $scope.participantInfo.SessionID));
            }

            var performAction = function (action) {
                if (!action) { return; }
                if (action.type === "OpenApplication") {
                    $scope.onExternalAppOpen(action.event);
                }
                if (action.type === "ShowProject") {
                    goToView({ type: "ProjectDetail", code: action.parameters.code });
                }
                if (action.type === "JoinProject") {
                    goToView({ type: "ProjectDetail", code: action.parameters.code, join: true });
                }
                if (action.type === "AddProviderAccount") {
                    if (typeof (action.parameters) === 'string' || !action.parameters.providerID) {
                        goToView({ type: "ProviderSearch", previousLocation: action.parameters });
                    }
                    else {
                        linkAccount(action.parameters.providerID, action.parameters.redirectPath, action.parameters.existingAccountID);
                    }
                }
                if (action.type === "ConnectExternalAccount") {
                    if (!action.parameters.externalAccountProviderID) {
                        const currentRelativeUrl = $window.location.pathname + $window.location.hash;
                        goToView({ type: "ProviderSearch", previousLocation: currentRelativeUrl });
                    }
                    else {
                        connectExternalAccount(
                            action.parameters.externalAccountProviderID,
                            action.parameters.messageID,
                            action.parameters.openNewWindow,
                            action.parameters.width,
                            action.parameters.height);
                    }
                }
                if (action.type === "ShowMyProviderAccounts") {
                    goToView({ type: "MyProviderAccounts" });
                }
                if (action.type === "ShowWebVisualization") {
                    goToView({ type: "WebVisualization", patientID: action.patientID, visualizationKey: action.parameters });
                }
                if (action.type === "StartSurvey") {
                    $scope.currentSurvey = {
                        surveyID: action.parameters.surveyID,
                        projectRecordAuthorityCode: action.parameters.studyRACode
                    };
                }
                if (action.type === "StartTask") {
                    $scope.currentSurvey = {
                        taskID: action.parameters
                    }
                }
                if (action.type === "ShowDashboard") {
                    goToView({ type: "Dashboard", dashboardKey: action.parameters.dashboardKey, patientID: action.parameters.patientID });
                }
                if (action.type === "ShowNewsFeed") {
                    goToView({ type: "NewsFeed", feed: action.parameters, patientID: action.patientID });
                }
                if (action.type === "Share") {
                    goToView({ type: "Share" });
                }
                if (action.type === "ShowPatientEventsViewer") {
                    goToView({ type: "PatientEventsViewer", view: action.parameters, patientID: action.patientID });
                }
                if (action.type === "CancelAccount") {
                    $scope.showCancelAccount = true;
                }
                if (action.type === "UpdateEmail") {
                    $scope.showUpdateEmailSurvey = true;
                    $scope.currentEmail = action.parameters;
                }
                if (action.type === "UpdatePhoneNumber") {
                    $scope.showUpdateMobileNumberSurvey = true;
                    $scope.currentMobileNumber = action.parameters;
                }
                //project-scoped actions (safe for completion actions in surveys)
                if (action.type === "ShowTab") {
                    var targetTab;
                    if (typeof (action.parameters) === 'string') {
                        targetTab = action.parameters;
                    } else {
                        targetTab = action.parameters.key;
                    }

                    if (!targetTab) { return; }


                    const selectedTabBar = $scope.participantInfo.ProjectTabBars?.find(t => t.ProjectID == $scope.selectedProject);

                    const tab =
                        selectedTabBar?.Tabs.find((t) => t.Key === targetTab) ||
                        $scope.participantInfo.Tabs.find((t) => t.Key === targetTab);
                    if (tab) {
                        const project = $scope.selectedProject || "-";
                        $location.path(
                            `/${project}/${targetTab}/${getUrlEncodedViewForTab(tab.Type, tab.Properties, $scope.participantInfo.SessionID, action.query)}`
                        );
                    }
                }
                if (action.type === "ShowParticipantDashboard") {
                    if (!action.parameters.dashboardKey) { return; }
                    goToView({ type: "Dashboard", dashboardKey: action.parameters.dashboardKey, patientID: action.patientID });
                }
                if (action.type === "ShowParticipantWebVisualization") {
                    if (!action.parameters.visualizationKey) { return; }
                    goToView({ type: "WebVisualization", patientID: action.patientID, visualizationKey: action.parameters.visualizationKey, restrictToProject: true });
                }
                if (action.type === "ShowParticipantWebVisualizationPDF") {
                    if (!action.parameters.visualizationKey) { return; }
                    var url = "webvisualization/webvisualizationpdf?visualizationKey=" + encodeURIComponent(action.parameters.visualizationKey) + "&patientID=" + encodeURIComponent(action.patientID) + "&restrictToProject=true";
                    if (action.parameters.landscape) {
                        url = url + "&landscape=true";
                    }
                    if (action.parameters.htmlViewerZoom) {
                        url = url + "&htmlViewerZoom=" + encodeURIComponent(action.parameters.htmlViewerZoom);
                    }
                    window.open(ceUrl.make(url));
                }
                if (action.type === "StartParticipantSurvey") {
                    if (!action.parameters.surveyName) { return; }
                    $scope.currentSurvey = {
                        surveyName: action.parameters.surveyName,
                        editResultID: action.parameters.options?.editResultID,
                        event: action.parameters.options?.event,
                        participantID: action.patientID
                    };
                }
                if (action.type === "OpenExternalLink") {
                    var url;
                    if (typeof (action.parameters) === 'string') {
                        url = action.parameters;
                    } else {
                        url = action.parameters.url;
                    }
                    if (!url) { return; }
                    window.open(url);
                }
            };

            $scope.$on("performAction", function (evt, action) {
                performAction(action);
            });

            $scope.$on("surveyFinished", function (event, reason, result, completionAction) {
                var surveyDidFinishParameters = getSurveyDidFinishParameters(reason);
                if (result) {
                    $scope.currentSurvey = null;
                    $scope.showUpdateEmailSurvey = false;
                    $scope.showUpdateMobileNumberSurvey = false;
                    loadParticipantInfo();
                    $scope.$broadcast("refreshDashboard");
                    $scope.$broadcast("surveyDidFinish", surveyDidFinishParameters);
                    performAction(completionAction);
                }
                else {
                    $scope.$broadcast("refreshDashboard");
                    $scope.$broadcast("surveyDidFinish", surveyDidFinishParameters);
                    $scope.currentSurvey = null;
                    $scope.showUpdateEmailSurvey = false;
                    $scope.showUpdateMobileNumberSurvey = false;
                }
            });

            function getSurveyDidFinishParameters(reason) {
                var parameters = {
                    reason: reason,
                    type: "surveyDidFinish"
                };

                if ($scope.currentSurvey && $scope.currentSurvey.surveyName) {
                    parameters.surveyName = $scope.currentSurvey.surveyName;
                }

                if ($scope.currentSurvey && $scope.currentSurvey.taskID) {
                    parameters.taskID = $scope.currentSurvey.taskID;
                }

                return parameters;
            }

            $scope.$on("reloadDashboard", function () {
                loadParticipantInfo();
                $scope.$broadcast("refreshDashboard");
            });

            $scope.$on("NavigateToView", function (evt, view) {
                goToView(view);
            });

            $scope.$watch("currentView", checkViewIsInSession);
            $scope.$watch("participantInfo", checkViewIsInSession);
            function checkViewIsInSession() {
                if (!$scope.participantInfo || !$scope.participantInfo.SessionID || !$scope.currentView) {
                    return;
                }
                if (!$scope.currentView.SessionID || $scope.currentView.SessionID !== $scope.participantInfo.SessionID) {
                    showDefaultTab();
                }
            }

            $scope.$on("$routeChangeSuccess", function (event, currentRoute, previousRoute) {

                //cancel any open surveys
                $scope.$broadcast("cancelSurvey");

                $scope.modalView = undefined;

                if (currentRoute.params.linkIdentifier) {
                    var apiUrl = 'api/link/' + currentRoute.params.linkIdentifier + '/' + currentRoute.params.actionIdentifier;
                    $http.get(ceUrl.make(apiUrl)).then(function (response) {
                        var actionModel = response.data;
                        let action = {};
                        if (actionModel.Type === 'StartSurvey') {
                            action = {
                                type: 'StartParticipantSurvey',
                                patientID: actionModel.ParticipantID,
                                parameters: {
                                    surveyName: actionModel.Properties.SurveyName,
                                },
                                tabKey: actionModel.Properties.TabKey
                            };
                        }
                        else if (actionModel.Type === 'ShowTab') {
                            action = {
                                type: 'ShowTab',
                                parameters: actionModel.Properties.TabKey,
                                // $location.search() only returns an object.  This is the only actual way to get the query string as an actual string.
                                query: $location.url().substr($location.path().length)
                            };
                        }
                        else if (actionModel.Type === 'ShowDynamicVisualization') {
                            action = {
                                type: 'ShowParticipantWebVisualization',
                                patientID: actionModel.ParticipantID,
                                parameters: {
                                    visualizationKey: actionModel.Properties.DynamicVisualizationKey
                                }
                            };
                        }
                        action.projectID = actionModel.ProjectID;
                        $scope.pendingAction = action;
                        loadParticipantInfo();
                    }).catch(function (error) {
                        $location.path("/");
                    });
                } else if (currentRoute.params.projectID) {
                    if (!$scope.participantInfo) {
                        loadParticipantInfo();
                    }
                    $timeout(function () {
                        if ($scope.selectedProject !== currentRoute.params.projectID) {
                            $scope.selectedProject = currentRoute.params.projectID;
                        }

                        if ($scope.selectedProject === "-") {
                            $scope.selectedProject = null;
                        }
                        $scope.selectedTab = currentRoute.params.rootTab;
                        //null out the current view to make sure all components refresh appropriately
                        $scope.currentView = null;
                        $timeout(function () {
                            $scope.currentView = decodeUrlBase64(currentRoute.params.view);

                            if ($scope.currentView.type === "ExternalApplication" && !$scope.modalView) {
                                initializeExternalAppStack($scope.currentView.url);
                            }

                            if ($scope.pendingAction) {
                                // this does NOT trigger a route change event because we set route.reloadOnSearch=false
                                $location.search({});
                                performAction($scope.pendingAction);
                                $scope.pendingAction = null;
                            }
                        });
                    });
                } else {
                    loadParticipantInfo();
                }

                captureDeviceInfo();
            });

            let navigationProps = null;
            $scope.getNavigationProps = function () {
                var newProps = {
                    colorScheme: $scope.getColorScheme(),
                    selectedTabKey: $scope.selectedTab,
                    participantStatus: $scope.participantInfo,
                    selectedProjectID: $scope.selectedProject,
                    currentLocaleCode: $scope.currentLanguage,
                    onChangeLocale: $scope.changeLanguage,
                    brandConfiguration: brandConfiguration,
                    sessionID: $scope.participantInfo.SessionID,
                    allLocales: configuration.AvailableLocales
                }
                if (!angular.equals(navigationProps, newProps)) {
                    navigationProps = newProps;
                }
                return navigationProps;
            }

            let tabsProps = null;
            $scope.getTabsProps = function () {
                let selectedTabBar = $scope.participantInfo?.ProjectTabBars?.find(t => t.ProjectID == $scope.selectedProject);
                if (!selectedTabBar) {
                    return undefined;
                }

                let newProps = {
                    colorScheme: $scope.getColorScheme(),
                    selectedTabKey: $scope.selectedTab,
                    tabs: selectedTabBar.Tabs,
                    styles: selectedTabBar.ProjectStyle,
                    projectID: selectedTabBar.ProjectID,
                    responsive: true,
                    sessionID: $scope.participantInfo.SessionID,
                }
                if (!angular.equals(tabsProps, newProps)) {
                    tabsProps = newProps;
                }
                return tabsProps;
            }

            $scope.$on("ShowNewsFeedDrilldownModal", function (event, eventData) {
                $scope.drilldownData = eventData;
                $scope.drilldownType = 'Event';
            });

            function initializeExternalAppStack(url) {
                $scope.modalView = {
                    applications: [{
                        url: url
                    }],
                    modalView: null
                };
            }

            function getTopModal(stack) {
                if (!stack.modalView) {
                    return stack;
                }
                return getTopModal(stack.modalView);
            }

            $scope.onExternalAppOpen = function (event) {
                if (!$scope.modalView) {
                    initializeExternalAppStack(event.url);
                }

                var topModal = getTopModal($scope.modalView);

                if (event.modal) {
                    topModal.modalView = {
                        applications: [{
                            url: event.url
                        }],
                        modalView: null
                    };
                }
                else {
                    if (!$scope.modalView.modalView) {
                        goToView({
                            url: event.url,
                            patientID: $scope.currentView.patientID,
                            type: "ExternalApplication"
                        });
                    }
                    else {
                        topModal.applications.push({ url: event.url });
                    }
                }
            };

            $scope.onExternalAppDismiss = function () {
                dismissTopModal($scope.modalView);

                if (!$scope.modalView.modalView) {
                    $scope.$broadcast("applicationDidBecomeVisible", { type: "applicationDidBecomeVisible" });
                }
            };

            function dismissTopModal(stack) {
                if (!stack.modalView) return;

                if (stack.modalView.modalView) {
                    dismissTopModal(stack.modalView);
                }
                else {
                    stack.modalView = null;
                }
            }

            $scope.onExternalAppBack = function () {
                if (!$scope.modalView.modalView) {
                    window.history.back();
                }
                else {
                    var topModal = getTopModal($scope.modalView);
                    if (topModal.applications.length > 1) {
                        topModal.applications.pop();
                    }
                }
            };

            $scope.logout = function () {
                ActiveLogout.Logout(true);
            }

            $window.addEventListener("message", messageHandler);

            function messageHandler(event) {
                if (event.origin !== $window.location.origin) return;

                if (event.data && event.data.name === "ConnectExternalAccountResponse") {
                    $scope.$broadcast("connectExternalAccountDidFinish", event.data);
                }
            }

            const bc = new BroadcastChannel("ConnectExternalAccount");
            bc.onmessage = (event) => {
                if (event.data && event.data.name === "ConnectExternalAccountResponse") {
                    $scope.$broadcast("connectExternalAccountDidFinish", event.data);
                }
            }

            function calculateVerticalHeightUnitSize() {
                var vh = $window.innerHeight * 0.01;
                document.documentElement.style.setProperty('--vh', vh + 'px');
            }

            $scope.getColorScheme = function () {
                let projectTabBar = $scope.participantInfo?.ProjectTabBars?.find(t => t.ProjectID == $scope.selectedProject);
                if (!projectTabBar) {
                    return "Light";
                }

                let colorScheme = projectTabBar.ProjectStyle?.SupportedColorSchemes ?? "LightAndDark";
                let darkModePreferred = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
                if (colorScheme === "LightAndDark" && darkModePreferred) {
                    return "Dark";
                }
                else if (colorScheme === "LightAndDark" && !darkModePreferred) {
                    return "Light";
                }
                return colorScheme;
            }

            function updateBodyColorScheme() {
                document.body.classList.remove("color-scheme-light");
                document.body.classList.remove("color-scheme-dark");
                document.body.classList.add("color-scheme-" + $scope.getColorScheme().toLowerCase());
            }

            function checkSupportedLanguage() {
                if (!$scope.selectedProject) return;
                let projectTabBar = $scope.participantInfo?.ProjectTabBars?.find(t => t.ProjectID == $scope.selectedProject);
                if (!projectTabBar) return;
                if (!projectTabBar.SupportedLocales.includes($scope.currentLanguage)) {
                    $scope.changeLanguage(projectTabBar.DefaultLocale);
                }
            }

            $scope.$watch("selectedProject", updateBodyColorScheme);
            $scope.$watch("participantInfo", updateBodyColorScheme);
            $scope.$watch("selectedProject", checkSupportedLanguage);
            $scope.$watch("participantInfo", checkSupportedLanguage);

            calculateVerticalHeightUnitSize();

            $($window).on("resize", calculateVerticalHeightUnitSize);
        }
    ]);

    myDataHelpsModule.config(["$routeProvider", "$translateProvider", "translateConfigurationProvider",
        function ($routeProvider, $translateProvider, translateConfigurationProvider) {
            $routeProvider.when("/",
                {
                    template: ""
                });
            $routeProvider.when("/p/:linkIdentifier/:actionIdentifier",
                {
                    template: "",
                    reloadOnSearch: false
                });
            $routeProvider.when("/:projectID/:rootTab/:view",
                {
                    template: "",
                    reloadOnSearch: false
                });

            translateConfigurationProvider.$get().configure($translateProvider, configuration.AvailableLocales);
        }]);

    angular.bootstrap($(".mydatahelps-app"), ["MyDataHelpsModule"]);
});